import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "placeholder", "removeBtn", "previewContainer", "urlInput", "urlToggle"]
  static values = { hasImage: Boolean }

  connect() {
    this.updateState()
  }

  remove() {
    // Clear the hidden input
    const input = this.element.querySelector('input[type="hidden"], input[type="text"]')
    if (input) {
      input.value = ""
    }

    // Update UI
    this.hasImageValue = false
    this.updateState()
  }

  toggleUrl() {
    if (this.hasUrlInputTarget) {
      this.urlInputTarget.classList.toggle("hidden")
    }
  }

  hasImageValueChanged() {
    this.updateState()
  }

  updateState() {
    const hasImage = this.hasImageValue || (this.hasPreviewTarget && this.previewTarget.src && !this.previewTarget.src.endsWith('/'))

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.toggle("hidden", hasImage)
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.toggle("hidden", !hasImage)
    }

    if (this.hasRemoveBtnTarget) {
      this.removeBtnTarget.classList.toggle("hidden", !hasImage)
    }

    if (this.hasPreviewContainerTarget) {
      this.previewContainerTarget.classList.toggle("image-upload-preview--has-image", hasImage)
    }
  }
}
